import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components/macro'

const Container = styled.div`
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background: ${({ theme }) => theme.colors.defaultBackground};
  box-shadow: ${({ theme }) => theme.shadows.top};
  min-height: ${({ theme }) => theme.sizeByFactor(8.1)};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding 0 ${({ theme }) => theme.sizeByFactor(2.5)};
  color: ${({ theme }) => theme.colors.actionsStandard};
`

const CarSelectToolbar = ({ children }) => {
  return <Container>{children}</Container>
}

CarSelectToolbar.propTypes = {
  children: PropTypes.node.isRequired,
}

export default CarSelectToolbar
